import { render } from "./BrandAdmin.vue?vue&type=template&id=6294518f&scoped=true"
import script from "./BrandAdmin.vue?vue&type=script&lang=js"
export * from "./BrandAdmin.vue?vue&type=script&lang=js"

import "./BrandAdmin.vue?vue&type=style&index=0&id=6294518f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6294518f"]])

export default __exports__